import React from "react";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
export const wrapRootElement = ({ element }) => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey="6Lce9rwaAAAAAP0ftdjXtqv5xcdqlsWBsYcXIZ7n">
      {element}
    </GoogleReCaptchaProvider>
  );
};
